import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SidebarNavButton = ({ icon, label, active = false, comingSoon = false, onClick }) => (
  <button
    type="button"
    className={`sidebar__item ${active ? "sidebar__item--active" : ""} ${comingSoon ? "sidebar__item--soon" : ""}`}
    onClick={onClick}
    title={comingSoon ? "Coming soon" : undefined}
  >
    <span className="sidebar__icon-wrap">
      <FontAwesomeIcon icon={icon} className="sidebar__icon" />
      {comingSoon && <span className="sidebar__soon-badge">Soon</span>}
    </span>
    <span className="sidebar__label">{label}</span>
  </button>
);

export default SidebarNavButton;
